function formatDuration(milliseconds) {
  const ms = milliseconds % 1000;
  const seconds = parseInt((milliseconds / 1000) % 60);
  const minutes = parseInt((milliseconds / (1000 * 60)) % 60);
  const hours = parseInt((milliseconds / (1000 * 60 * 60)) % 24);
  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  let eta = '';

  if (days) {
    eta += `${days}${days > 1 ? 'days ' : 'day '}`;
  }
  if (hours) {
    eta += `${hours}${hours > 1 ? 'hrs ' : 'hr '}`;
  }
  if (minutes) {
    eta += `${minutes}${minutes > 1 ? 'mins ' : 'min '}`;
  }
  if (seconds) {
    eta += `${seconds}${seconds > 1 ? 'secs ' : 'sec '}`;
  }
  if (ms) {
    eta += `${ms}ms`;
  } else if (eta === '') {
    eta = '0ms';
  }
  return eta;
}

function formatTime(date) {
  const hrs = date.getHours();
  let ms = (Math.round(date.getMilliseconds() / 10) * 10) / 10;
  let seconds = date.getSeconds();
  let minutes = date.getMinutes();
  let hours = hrs > 12 ? hrs % 12 : hrs;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  ms = ms < 10 ? `0${ms}` : ms;
  return `${hours}:${minutes}:${seconds}:${ms} ${hrs >= 12 ? 'PM' : 'AM'}`;
}

export { formatDuration, formatTime };
